import { pixelateImageData } from "./pixelationLogic";

// The function's own name is not preserved by production minifiers — its
// serialized source may declare e.g. `function So(...)` — so bind it to the
// name the handler calls instead of relying on the declaration name.
export function buildWorkerScript(
  fn: typeof pixelateImageData,
): string {
  return `const pixelateImageData = ${fn.toString()};
self.onmessage = function (e) {
  const { imageData, width, height, pixelSize, legoColors, dither, mergeRareColors } = e.data;
  const result = pixelateImageData(
    new Uint8ClampedArray(imageData),
    width,
    height,
    pixelSize,
    legoColors,
    { dither: !!dither, mergeRareColors: !!mergeRareColors },
  );
  self.postMessage(result);
};
`;
}

const workerScript = buildWorkerScript(pixelateImageData);

export interface PixelationInput {
  imageData: ArrayBuffer;
  width: number;
  height: number;
  pixelSize: number;
  legoColors: ReadonlyArray<{ r: number; g: number; b: number }>;
  dither?: boolean;
  mergeRareColors?: boolean;
}

export function createPixelationWorker(): { worker: Worker; url: string } {
  const blob = new Blob([workerScript], { type: "application/javascript" });
  const url = URL.createObjectURL(blob);
  const worker = new Worker(url);
  return { worker, url };
}
